import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createListViewActions } from './actions';
import { ListViewActions, ListViewState } from './types';

export const useListViewStore = create<ListViewState & ListViewActions>()(
    immer((set, get, store) => ({
        listViews: [],
        loading: false,
        selectedListView: null,
        loadingListView: false,
        error: undefined,
        ...createListViewActions(set, get, store),
    })),
);
